const storeSuffix = 'QueuedCompanies';
const localStorage = process.title === 'browser' ? window.localStorage : false;

// Actions
export const ADD_TO_QUEUE = `AddToQueueAction${storeSuffix}`;
export const REMOVE_FROM_QUEUE = `RemoveFromQueueAction${storeSuffix}`;
export const FETCH_FROM_LOCAL_STORAGE = `FetchFromLocalStorageAction${storeSuffix}`;
export const DISMISS_FIRST_COMPANY_SELECTION_NOTICE = `dismissFirstCompanySelectionNoticeEAction${storeSuffix}`;

// Mutations
export const SAVE_COMPANY = `saveCompanyMutation${storeSuffix}`;
export const UPDATE_COMPANIES = `updateCompaniesMutation${storeSuffix}`;
export const SET_FIRST_COMPANY_SELECTION = `setFirstCompanySelectionMutation${storeSuffix}`;

//Getters
export const GET_COMPANIES = `getCompaniesGetter${storeSuffix}`;
export const IS_FIRST_COMPANY_SELECTION = `getIsFirstCompanySelectionGetter${storeSuffix}`;
export const GET_CONTRACTOR_IDS = `getContractorIdsGetter${storeSuffix}`;
export const GET_ERROR = `getError${storeSuffix}`;

export const modelState = () => ({
    queuedCompanies: {
        data: [],
        error: false,
        isFirstCompanySelection: false,
    },
});

export const actions = {
    [FETCH_FROM_LOCAL_STORAGE]: ({ state, commit }) => {
        let dataStorage =
            localStorage && localStorage.getItem('companies')
                ? JSON.parse(localStorage.getItem('companies'))
                : [];

        commit(UPDATE_COMPANIES, dataStorage);
    },
    [DISMISS_FIRST_COMPANY_SELECTION_NOTICE]: ({ commit }) => {
      if (process.title === 'browser') {
          window.$cookies.set('popupFirstCompanySelection', 'true', Infinity, '/');
      }
      commit(SET_FIRST_COMPANY_SELECTION, false);
    },
    [ADD_TO_QUEUE]: ({ state, commit }, company) => {
        if (state.queuedCompanies.data.length === 0) {
          console.log('matched length of queued companies');
            const hasSeenMessageBefore = process.title === 'browser' && window.$cookies.get('popupFirstCompanySelection') === 'true';
            console.log('value of cookie: ', window.$cookies.get('popupFirstCompanySelection'));
            if (!hasSeenMessageBefore) {
              console.log('has not seen before');
              commit(SET_FIRST_COMPANY_SELECTION, true);
            }
        }
        if (state.queuedCompanies.data.length >= 6) {
            // Do nothing, we've reached the maximum allowed
        } else if (state.queuedCompanies.data.length > 0) {
            let matches = state.queuedCompanies.data.filter(
                c => c.Id === company.Id
            );

            // If the company is not already added, add it
            if (matches.length <= 0) {
                commit(SAVE_COMPANY, company);
            }
        } else {
            commit(SAVE_COMPANY, company);
        }
    },
    [REMOVE_FROM_QUEUE]: ({ state, commit }, companyId) => {
        let remainingCompanies = state.queuedCompanies.data.filter(company => {
            if (company.Id !== companyId) {
                return company;
            }
        });

        commit(UPDATE_COMPANIES, remainingCompanies);
    },
};

export const mutations = {
    [SAVE_COMPANY]: (state, company) => {
        state.queuedCompanies.data.push(company);
        if (localStorage) {
            localStorage.setItem(
                'companies',
                JSON.stringify(state.queuedCompanies.data)
            );
        }
    },
    [SET_FIRST_COMPANY_SELECTION]: (state, value) => {
        state.queuedCompanies.isFirstCompanySelection = value;
    },
    [UPDATE_COMPANIES]: (state, companies) => {
        state.queuedCompanies.data = companies;
        if (localStorage) {
            localStorage.setItem(
                'companies',
                JSON.stringify(state.queuedCompanies.data)
            );
        }
    },
};

export const getters = {
    [GET_COMPANIES]: state => {
        return state.queuedCompanies.data;
    },
    [GET_CONTRACTOR_IDS]: state => {
        //Should return list of contractor ids. Now return company ids
        return state.queuedCompanies.data.map(item => item.Id);
    },
    [IS_FIRST_COMPANY_SELECTION]: state => {
        return state.queuedCompanies.isFirstCompanySelection;
    },
    [GET_ERROR]: state => {
        return state.queuedCompanies.error;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/queued-companies-model.js